var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup21X(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 22,
    viewBox: "0 0 25 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 16.5H12.5V21.5H17V16.5Z",
    fill: "#97A2C3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 8.5H6.5V13.5H11.5V8.5Z",
    fill: "#97A2C3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 0.5H18V5.5H24.5V0.5Z",
    fill: "#97A2C3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7087 6.05785H0V0H24.7087V6.05785ZM0.569064 5.4885H24.1397V0.569347H0.569064V5.4885Z",
    fill: "#233A80"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9274 14.029H0.0112305V7.97119H11.9274V14.029ZM0.568919 13.4597H11.347V8.54054H0.568919V13.4597Z",
    fill: "#233A80"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.402 22H0V15.9421H17.402V22ZM0.569064 21.4306H16.8329V16.5115H0.569064V21.4306Z",
    fill: "#233A80"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5066 0.182373H17.9375V5.75059H18.5066V0.182373Z",
    fill: "#233A80"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.03342 8.27808H6.46436V13.8463H7.03342V8.27808Z",
    fill: "#233A80"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9406 16.1238H12.3716V21.692H12.9406V16.1238Z",
    fill: "#233A80"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 6V0.5H18.5V6H0.5Z",
    fill: "#233A80"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M0 14V8H7V14H0Z",
    fill: "#233A80"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M0 22V16H13V22H0Z",
    fill: "#233A80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup21X);
export default __webpack_public_path__ + "static/media/Group21x.22faec0449ae22b74ba8a2b9f71e7d46.svg";
export { ForwardRef as ReactComponent };